import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { list, reset, filter, sort } from '../../actions/CandidateOneWayInterview/list';
import {handleListUpdate, pagination, renderLinks} from "../../utils/entityList";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Moment from 'react-moment';
import filtersStorage from '../../utils/filtersStorage';
import FilterForm from "./FilterForm";
import {SortableTableCells} from "../../utils/filterForm";
import TableFooter from "@material-ui/core/TableFooter";
import {getRoutePage} from "../../utils/routes";

const defaultFilters = {
  'completedAt__exists__': true,
};

class CandidateOneWayInterviewList extends Component {
  static propTypes = {
    retrieved: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    list: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    filter: PropTypes.func.isRequired,
    filtersData: PropTypes.object,
    sort: PropTypes.func.isRequired,
    sortData: PropTypes.object,
  };

  componentDidMount() {
    const storageName = 'candidate_one_way_interview';
    this.props.filter(filtersStorage.get(storageName, defaultFilters));
    this.props.sort(filtersStorage.getSort(storageName));
  }

  componentDidUpdate(prevProps) {
    handleListUpdate('one_way_interviews', this.props, prevProps);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    return (
      <div>

        {this.props.loading && (
          <div className="alert alert-info">Loading...</div>
        )}
        {this.props.error && (
          <div className="alert alert-danger">{this.props.error}</div>
        )}

        <FilterForm
          initialValues={this.props.filtersData}
          onSubmit={this.props.filter}
          resetFilter={this.props.filterReset}
        />

        <div style={{'overflowX': 'auto'}}>
          <Table className="table table-responsive table-striped table-hover one-way-interview mb-0">
            <TableHead>
              <TableRow>
                <SortableTableCells sort={this.props.sort} sortData={this.props.sortData} fields={{
                  'id': 'ID',
                  'request.company.name': 'Company',
                  'request.job.title': 'Job Title',
                  'startedAt': 'Started At',
                  'completedAt': 'Completed At',
                }} />
                <TableCell colSpan={1} />
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.retrieved &&
                this.props.retrieved['hydra:member'].map(item => (
                  <TableRow key={item['@id']}>
                    <TableCell scope="row" className="align-middle">
                      {renderLinks('on-demand-interviews', item, (oneWayInterview) => oneWayInterview['id'])}
                    </TableCell>
                    <TableCell className="align-middle">
                      {renderLinks('companies', item['request']['company'], (company) => company['name'])}
                    </TableCell>
                    <TableCell className="align-middle">{item['request']['job']['title']}</TableCell>
                    <TableCell className="align-middle">{item['startedAt'] ? <Moment>{item['startedAt']}</Moment> : 'Not started'}</TableCell>
                    <TableCell className="align-middle">{item['completedAt'] ? <Moment>{item['completedAt']}</Moment> : 'Not completed'}</TableCell>
                    <TableCell className="align-middle">
                      <Link to={`show/${encodeURIComponent(item['@id'])}`}>
                        <span className="fa fa-eye" aria-hidden="true" />
                        <span className="sr-only">Show</span>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <Table className="table table-responsive no-border">
          <TableFooter>
            <TableRow>
              {pagination(this.props.retrieved, getRoutePage(this.props.match))}
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    retrieved,
    loading,
    error,
    filtersData,
    sortData,
  } = state.candidateonewayinterview.list;
  return { retrieved, loading, error, filtersData, sortData };
};

const mapDispatchToProps = dispatch => ({
  list: page => dispatch(list(page)),
  reset: () => dispatch(reset()),
  filter: (filtersData) => dispatch(filter(filtersData)),
  filterReset: () => dispatch(filter(defaultFilters)),
  sort: (sortData) => dispatch(sort(sortData)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CandidateOneWayInterviewList);
